export default __webpack_public_path__ + "8e6f51dbed05ae80f6ef9f2f821d2c89.svg";